import axios from 'axios'
import { differenceBy } from 'lodash'

export const state = {
  products: [],
  isRequest: false
}

export const getters = {
  allProducts: state => state.products,
  isRequest: state => state.isRequest,
  availableProducts: (state, getters) => {
    return differenceBy(state.products, getters.activeSubscriptions, 'tar_id')
  }
}

export const actions = {
  getAllProducts ({ commit }) {
    commit('REQUEST_PRODUCT')
    axios.get('products').then(promise => {
      commit('RECEIVE_PRODUCTS', promise.data.results)
    })
  }
}

export const mutations = {
  RECEIVE_PRODUCTS (state, products) {
    state.isRequest = false
    state.products = products
  },
  REQUEST_PRODUCT (state, payload) {
    state.isRequest = true
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
